/* unplugin-vue-components disabled */import script from "./WeeklyReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeeklyReport.vue?vue&type=script&lang=ts&setup=true"

import "./WeeklyReport.vue?vue&type=style&index=0&id=4eb83ff0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eb83ff0"]])

export default __exports__